export enum AttachmentPermissions {
  PERMISSION_WRITE = 'W',
  PERMISSION_READ = 'R',
  NO_PERMISSION = 'NO_PERMISSION'
}
